// The enum's value IS its key (not a display label) - this is what actually gets persisted as
// DocumentEntry.type/ExpiringDocument.missingDocumentType, matching document-select.component's
// `[value]="dt.key"` binding. Use DocumentTypeLabel below for the human-readable Hungarian text.
export enum DocumentType {
  HEALTH_CERTIFICATE = 'HEALTH_CERTIFICATE',
  LAB_RESULTS = 'LAB_RESULTS',
  VACCINATION = 'VACCINATION',
  CONTRACT = 'CONTRACT',
  SINGUP = 'SINGUP',
  EXAM = 'EXAM',
  TRACKING_SHEET = 'TRACKING_SHEET',
  MATESZE_THERAPY_CERTIFICATES = 'MATESZE_THERAPY_CERTIFICATES',
  MATESZE_SERVICE_CERTIFICATES = 'MATESZE_SERVICE_CERTIFICATES',
  ADI_THERAPY_CERTIFICATES = 'ADI_THERAPY_CERTIFICATES',
  ADI_SERVICE_CERTIFICATES = 'ADI_SERVICE_CERTIFICATES',
}

export const DocumentTypeLabel: Record<DocumentType, string> = {
  [DocumentType.HEALTH_CERTIFICATE]: 'Állatorvosi eü. igazolás',
  [DocumentType.LAB_RESULTS]: 'Labor lelet',
  [DocumentType.VACCINATION]: 'Oltási könyv',
  [DocumentType.CONTRACT]: 'Szerződés',
  [DocumentType.SINGUP]: 'Jelentkezési lap',
  [DocumentType.EXAM]: 'Vizsgajegyzőkönyv',
  [DocumentType.TRACKING_SHEET]: 'Utánkövetési lap',
  [DocumentType.MATESZE_THERAPY_CERTIFICATES]: 'MATESZE Terápiás Igazolvány',
  [DocumentType.MATESZE_SERVICE_CERTIFICATES]: 'MATESZE Segítő Igazolvány',
  [DocumentType.ADI_THERAPY_CERTIFICATES]: 'ADI Terápiás Igazolvány',
  [DocumentType.ADI_SERVICE_CERTIFICATES]: 'ADI Segítő Igazolvány',
}

export const documentTypesArray = Object.values(DocumentType).map((key) => ({ key, value: DocumentTypeLabel[key] }))

// Same key==value convention as DocumentType - see comment above.
export enum TrainerDocumentType {
  CERTIFICATE = 'CERTIFICATE',
  TRAINING_CERTIFICATE = 'TRAINING_CERTIFICATE',
  OTHER = 'OTHER',
}

export const TrainerDocumentTypeLabel: Record<TrainerDocumentType, string> = {
  [TrainerDocumentType.CERTIFICATE]: 'Bizonyítvány',
  [TrainerDocumentType.TRAINING_CERTIFICATE]: 'Továbbképzés igazoléás',
  [TrainerDocumentType.OTHER]: 'Egyéb',
}

export const trainerDocumentTypesArray = Object.values(TrainerDocumentType).map((key) => ({ key, value: TrainerDocumentTypeLabel[key] }))

export class DocumentEntry {
  // type of DocumentType | TrainerDocumentType
  type!: string
  downloadUrl?: string
  fileType?: string
  documentDate?: Date
  createdAt!: Date
  createdBy!: string
  idCard?: {
    trainer: string
    idNumber: string
    expirationDate: string
    clientPhotoUrl: string
  }
}

export class ExpiringDocument {
  prevDocument?: DocumentEntry
  missingDocumentType: DocumentType
  expiryDate?: Date
  dogId: string
}
